import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useDispatch, useSelector } from 'react-redux'
import {
  List,
  ListItem,
  Hidden,
  Drawer,
  useMediaQuery,
} from '@material-ui/core'
import * as Actions from 'app/store/actions'
import {
  compose,
  prop,
  find,
  pipe,
  chain,
  propOr,
  sortWith,
  descend,
  ascend,
  propEq,
  filter,
} from 'ramda'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import Leftbar from './Leftbar'
import AccessControlMenu from 'app/auth/AccessControlMenu'
import { useTheme } from '@material-ui/core/styles'
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton'
import { usePlace } from 'commons/usePlace'
import { useAccessControl } from 'app/auth/useAccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { useFlag } from '@unleash/proxy-client-react'

const useStyles = makeStyles(() => ({
  active: {
    backgroundColor: 'rgba(233, 237, 241, 1)',
    color: '#183560 !important',
    fontWeight: 'bold !important',
    height: '60px',
  },
  default: {
    color: '#5D7290 !important',
    height: '60px',
  },
  navBar: {
    minWidth: '230px !important',
  },
  navbarDownLg: {
    minWidth: '280px !important',
  },
}))
const sortByParentId = (data, targetParentId) => {
  return sortWith([descend(propEq('parentId', targetParentId))])(data)
}

function NavbarWrapperLayoutMain(props) {
  const { history } = props
  const classes = useStyles()
  const navbar = useSelector(({ fuse }) => fuse.navbar)
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config)
  const place = usePlace()
  const navigation = useSelector(({ fuse }) => fuse.navigation)
  const { isGranted: isAdmin } = useAccessControl([AccessType.ADMINISTRATION])
  const mes_5122 = useFlag('mes_5122_navigation_support_manager_web')

  const folded = config.navbar.folded
  const foldedAndClosed = folded && !navbar.foldedOpen
  const foldedAndOpened = folded && navbar.foldedOpen
  const theme = useTheme()
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))
  const dispatch = useDispatch()
  const menuSelectedId = compose(
    prop('id'),
    find(prop('isSelected')),
  )(navigation)

  const getAllChildren = pipe(
    chain(propOr([], 'children')),
    filter((menu) => {
      return menu.id !== 'subscribers'
    }),
  )

  const subMenu = sortByParentId(getAllChildren(navigation), menuSelectedId)

  return (
    <AccessControlMenu>
      <Hidden mdDown>
        <div
          className={clsx('max-w-sm bg-white', classes.navBar)}
          onMouseEnter={() =>
            foldedAndClosed && dispatch(Actions.navbarOpenFolded())
          }
          onMouseLeave={() =>
            foldedAndOpened && dispatch(Actions.navbarCloseMobile())
          }
        >
          <List className="px-5 h-full">
            {subMenu.map((item) => {
              if (
                (!isAdmin && item.id === 'topics') ||
                (item.id === 'manage-channels' &&
                  place.enabledAutomatedCall === 0) ||
                (mes_5122 && item.id === 'Conversation')
              ) {
                return null
              }
              return (
                <ListItem
                  button
                  key={item.id}
                  className={clsx(
                    item.isSelected ? classes.active : classes.default,
                    'rounded text-14',
                    menuSelectedId === item.parentId ? 'visible' : 'invisible',
                  )}
                  onClick={() => {
                    if (item.type === 'link' && item.url) {
                      window.open(item.url, item.target)
                    } else {
                      history.push(item.url)
                    }
                  }}
                  data-testid={`${item.id}-button-menu`}
                >
                  {item.componentIcon && item.componentIcon}

                  <span>
                    <FormattedMessage id={item.localizedId} />
                  </span>
                </ListItem>
              )
            })}
          </List>
        </div>
      </Hidden>
      {isDownLg && (
        <Hidden lgUp>
          <Drawer
            anchor={config.navbar.position}
            variant="temporary"
            open={navbar.mobileOpen}
            classes={{
              paper: classes.navbarDownLg,
            }}
            onClose={() => dispatch(Actions.navbarCloseMobile())}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <div className="flex flex-1 h-screen">
              <Leftbar {...props} />
              <div className="w-full bg-white h-full overflow-hidden">
                <div className="flex justify-end w-full">
                  <NavbarMobileToggleButton className="w-64 h-48 p-0 mt-4 text-black" />
                </div>
                <List className="px-5">
                  {subMenu.map((item) => {
                    if (
                      (!isAdmin && item.id === 'topics') ||
                      (item.id === 'manage-channels' &&
                        place.enabledAutomatedCall === 0) ||
                      (mes_5122 && item.id === 'Conversation')
                    ) {
                      return null
                    }
                    return (
                      <ListItem
                        button
                        key={item.id}
                        className={clsx(
                          item.isSelected ? classes.active : classes.default,
                          'rounded text-14',
                          menuSelectedId === item.parentId
                            ? 'visible'
                            : 'invisible',
                        )}
                        onClick={() => {
                          if (item.type === 'link' && item.url) {
                            window.open(item.url, item.target)
                          } else {
                            dispatch(Actions.navbarCloseMobile())
                            history.push(item.url)
                          }
                        }}
                        data-testid={`${item.id}-button-menu`}
                      >
                        {item.componentIcon && item.componentIcon}

                        <span>
                          <FormattedMessage id={item.localizedId} />
                        </span>
                      </ListItem>
                    )
                  })}
                </List>
              </div>
            </div>
          </Drawer>
        </Hidden>
      )}
    </AccessControlMenu>
  )
}

export default NavbarWrapperLayoutMain
